import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import Text from './Text';

const baseStyles = ({ color }) => css`
  border-radius: 50%;
  border: 0 solid #666;
  background: ${color};
  text-align: center;
  box-sizing: content-box;
  display: inline-block;
`;

const sizeStyles = ({ theme, size, width }) => css`
  width: ${width || theme.typography.text[size].lineHeight};
  line-height: ${width || theme.typography.text[size].lineHeight};
`;

const CircleText = styled(Text)(baseStyles, sizeStyles);

CircleText.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
};

export default CircleText;
